var __TEMP__ = require('./_freeGlobal.js');var freeGlobal = __REQUIRE_DEFAULT__(__TEMP__);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = root;
